﻿﻿import { RecreationalDrug } from '../enums/index';


export interface IDrugUse {
    recreationalDrug: RecreationalDrug
}
